import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import { API_BASE_URL } from '../App';
import CostcoLogo from './CostcoLogo';
import { isCostcoChaseHost } from '../lib/productHost';

function finishLogin(sessionToken, navigate, homePath) {
	Cookies.set('session', sessionToken, { path: '/' });
	window.history.replaceState({}, '', homePath());
	navigate(homePath(), { replace: true });
}

function CostcoAuthCallback() {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const [error, setError] = useState('');

	const homePath = () => {
		if (isCostcoChaseHost()) return '/';
		if (window.location.pathname.startsWith('/costco')) return '/costco';
		return '/';
	};

	useEffect(() => {
		const session = searchParams.get('session');
		const code = searchParams.get('code');
		if (session) {
			finishLogin(session, navigate, homePath);
			return;
		}
		if (!code) {
			setError('Missing sign-in code. Try signing in again.');
			return;
		}
		(async () => {
			try {
				const res = await fetch(`${API_BASE_URL}/auth/exchange`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ code }),
				});
				const data = await res.json().catch(() => ({}));
				if (!res.ok || !data.sessionToken) {
					setError(data.error || 'Sign-in failed. Try again.');
					return;
				}
				finishLogin(data.sessionToken, navigate, homePath);
			} catch (e) {
				setError(e.message || 'Network error. Try again.');
			}
		})();
	}, [searchParams, navigate]);

	return (
		<div className="costco-page costco-page--center">
			<CostcoLogo compact />
			{error ? (
				<>
					<p className="costco-error-banner">{error}</p>
					<Link to="/login" className="costco-btn costco-btn--blue">
						Back to sign in
					</Link>
				</>
			) : (
				<p className="costco-auth-callback-msg">Signing you in…</p>
			)}
		</div>
	);
}

export default CostcoAuthCallback;
